/**
 * Zentrale Feature-Flags der Employee UI.
 *
 * `teamleadMailEnabled` blendet den Stammblatt-Wochenversand an die Teamleitungen
 * (#1269) aus: Menüpunkt „Versand an Teamleitungen", Route `/teamlead-mail` und den Schalter
 * in den Schuldaten. Freigeschaltet am 29.10.2026 (#1349), vorher ausgeblendet (#1282) —
 * ausschalten heißt: hier auf `false` setzen. Functions und Daten bleiben unberührt.
 */
export const FEATURE_FLAGS = {
  teamleadMailEnabled: true,
} as const;
